import {useEffect,useState} from 'react';
import DashboardHeader from "../components/DashboardHeader";
import {getDashboard} from "../services/dashboard";
import DashboardCards from "../components/DashboardCards";
import CompanyLinks from '../components/CompanyLinks';
import useAuthErrorHandler from '../hooks/useAuthErrorHandler';

function HomePage(props) {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const handleAuthError = useAuthErrorHandler();

    useEffect(() => {
        getDashboard(props.token).then((response) => {
            setData(response.data);
            setError(null);
        })
            .catch((err) => {
                console.log(err.message);
                // Check if it's a 401 error and redirect to login
                if (!handleAuthError(err)) {
                    const errorMessage = err.response?.data?.message || err.message;
                    setError(errorMessage);
                }
            })
            .finally(() => {
                setLoading(false);
            });
    },[]);

    if (loading) {
        return (
            <div className='dashboard-content'>
                <DashboardHeader
                    btnText="User management" 
                    link="/users" />
                <div className='dashboard-content-container'>
                    <div className='dashboard-content-header'>
                        <h2>Dashboard</h2>
                    </div>
                    <div className="text-center p-4">
                        <p>Loading dashboard...</p>
                    </div>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className='dashboard-content'>
                <DashboardHeader
                    btnText="User management" 
                    link="/users" />
                <div className='dashboard-content-container'>
                    <div className='dashboard-content-header'>
                        <h2>Dashboard</h2>
                    </div>
                    <div className="alert alert-danger">
                        <p>Error loading dashboard: {error}</p>
                    </div>
                </div>
            </div>
        );
    }

    if (!data) {
        return (
            <div className='dashboard-content'>
                <DashboardHeader
                    btnText="User management" 
                    link="/users" />
                <div className='dashboard-content-container'>
                    <div className='dashboard-content-header'>
                        <h2>Dashboard</h2>
                    </div>
                    <div className="alert alert-warning">
                        <p>No dashboard data available.</p>
                    </div>
                </div>
            </div>
        );
    }


    return (
        <div className='dashboard-content'>
            <DashboardHeader
                btnText="User management" 
                link="/users" />

            <div className='dashboard-content-container'>
                <div className='dashboard-content-header'>
                    <h2>Dashboard </h2>

                </div>
                <DashboardCards data={data}/>
                <div>
                    <CompanyLinks token={props.token}/>
                </div>
            </div>
        </div>
    );
  }
  
  export default HomePage;
  